export default __webpack_public_path__ + "static/media/search-white.fefb8257.svg";